module.exports = __webpack_public_path__ + "static/media/Diverse women.3ecbb8ef.png";